import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/index'

import cont from '@/components/conter'

import NotFoundPage from '@/components/NotFoundPage'


Vue.use(Router)

const router =   new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    { path: '*', component: NotFoundPage }
  ]
})





export default router;

// 获取原型对象push函数
const originalPush = Router.prototype.push

// 获取原型对象replace函数
const originalReplace = Router.prototype.replace

// 修改原型对象中的push函数
Router.prototype.push = function push(location){
  return originalPush.call(this , location).catch(err=>err)
}

// 修改原型对象中的replace函数
Router.prototype.replace = function replace(location){
  return originalReplace.call(this , location).catch(err=>err)
}



// WEBPACK FOOTER //
// ./src/router/index.js